import React from "react";
import cn from "classnames";
import { Icon } from "src/components";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  number: number;
  status: "active" | "inactive" | "done";
  children: React.ReactNode;
}

const SurveyStep = ({ number, status, children, className }: Props) => {
  return (
    <div
      className={cn(
        "flex flex-nowrap md:flex-wrap items-center p-2 pr-4 gap-2 rounded-3xl w-fit",
        {
          "bg-primary/10": status === "active",
          "bg-transparent": status !== "active",
        },
        className
      )}
    >
      <div
        className={cn(
          "flex w-6 h-6 justify-center items-center rounded-3xl shadow-blue-10",
          {
            "bg-primary": status === "active",
            "bg-white": status !== "active",
          }
        )}
      >
        <div
          className={cn("text-sm font-medium select-none", {
            "text-white": status === "active",
            "text-primary": status !== "active",
          })}
        >
          {status === "done" ? <Icon icon="checkmark" size={16} /> : number}
        </div>
      </div>
      <div
        className={cn(
          "text-base text-primary whitespace-nowrap md:whitespace-normal text-nowrap md:text-wrap",
          {
            "font-medium": status === "active",
            "font-normal": status !== "active",
          }
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default SurveyStep;
